<script>
import messages from '@/mixins/messages'
import TermsOfServiceLink from './TermsOfServiceLink.vue'
import PaymentMethod from '../components/PaymentMethod.vue'
import { UserVoucherResource } from '@/resources/voucher'

export default {
    name: 'VoucherPitch',
    mixins: [messages],
    components: {
        TermsOfServiceLink,
        PaymentMethod
    },
    computed: {
        amountCents() {
            let userValue = parseInt(this.amountDollars)

            if (!userValue) {
                return 1e4
            }

            return userValue * 100
        },
    },
    watch: {
        userResource() {
            this.emailToFromName = this.userResource.fullName()
        }
    },
    data() {
        return {
            loading: true,
            amountDollars: 100,
            emailTo: false,
            emailToEmail: '',
            emailToFromName: '',
            emailToComments: '',
            userCardDetails: {},
            userResource: null,
            voucherResource: null,
            showSuccess: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loading = true
                const extraData = !this.emailTo ? undefined : {
                    emailTo: this.emailToEmail,
                    emailFromName: this.emailToFromName,
                    emailComments: this.emailToComments
                }

                this.voucherResource = await UserVoucherResource.purchaseGiftCard(this.amountCents, extraData)
                this.showSuccess = true
                this.$emit('success', this.voucherResource)
            } catch(e) {
                throw this.axiosExtract(e)
            } finally {
                this.loading = false
            }
        },
        async onCardAdded() {
            this.userCardDetails = await this.userResource.getCard()
        },
        onSuccess() {
            this.$emit('done')
        },
        onClose() {
            this.$emit('close')
        }
    },
    async mounted() {
        this.userResource = await this.$store.dispatch('getUserResource')
        this.userCardDetails = await this.userResource.getCard()
        this.loading = false
    }
}
</script>

<template>
    <div class="voucher-pitch">
        <b-row v-if="!loading && !showSuccess">
            <b-col>
                <b-form @submit.prevent="onSubmit">
                    <b-form-group label="Valeur du Bon Cadeau" label-cols-md="6">
                        <b-input-group :prepend="currencySymbol()" append=".00">
                            <b-form-input type="number" v-model="amountDollars"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <hr />

                    <p><strong>Un code de bon vous sera envoyé par email.</strong> Ce code de bon peut être utilisé pour réserver des sessions pour tout type de simulateur à n'importe quelle date/heure.</p>
                    
                    <p><b-form-checkbox v-model="emailTo">Envoyer ce code de bon par email à quelqu'un de spécial</b-form-checkbox></p>

                    <div v-if="emailTo">
                        <b-form-group label="Adresse Email du Destinataire">
                            <b-form-input type="email" v-model="emailToEmail" placeholder="Adresse Email"  :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Votre Nom">
                            <b-form-input v-model="emailToFromName" placeholder="Votre Nom" :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Commentaires Supplémentaires" description="Maximum 200 caractères">
                            <b-form-textarea v-model="emailToComments" placeholder="Ex. 'Joyeux Anniversaire !'" maxlength="200"></b-form-textarea>
                        </b-form-group>
                    </div>
                    
                    <div v-if="!Object.keys(userCardDetails).length">
                        <hr />
                        <payment-method cols-lg="12" :user-resource="userResource" @success="onCardAdded">
                            <b-alert variant="success" show><b-icon icon="lock-fill" /> Votre carte ne sera pas encore débitée</b-alert>
                        </payment-method>
                    </div>
                    
                    <div v-else>
                        <b-alert variant="info" show>Votre <strong>{{ userCardDetails.brand }} se terminant par {{ userCardDetails.last4 }}</strong> sera débitée de {{ currencySymbol() }}{{ moneyFormat(amountCents) }}.</b-alert>
                        <small class="text-muted"><terms-of-service-link /></small>
                        <messages class="mt-3" />
                        <b-button type="submit" class="col-sm-12 mt-3" :disabled="loading">Acheter un Bon Cadeau</b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>

        <div v-else-if="showSuccess">
            <b-alert variant="success" show><strong>Succès ! Votre bon cadeau a été acheté !</strong> <span v-if="emailTo">Ce bon cadeau a également été envoyé à <strong>{{ emailToEmail }}</strong></span></b-alert>
            <p>Veuillez noter le code ci-dessous. Entrer ce code lors du paiement appliquera le solde de ce bon à votre coût de paiement.</p>
            <b-card header="Code du Bon">
                <h4 class="text-center mb-0">
                    {{ voucherResource }}
                </h4>
            </b-card>
            <b-button variant="primary" class="col-sm-12 mt-3" @click="onSuccess">Tout est fait</b-button>
        </div>

        <div v-else>
            <b-skeleton-wrapper>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-skeleton-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
</style>
